// libs
import React from 'react';

// components
import BaseCheckbox from './BaseCheckbox';
import CircularCheckbox from './CircularCheckbox';
import DefaultCheckbox from './DefaultCheckbox';
import { CheckboxProps } from './types';
import { CheckboxSize } from './types';

const Checkbox = React.forwardRef<
  HTMLButtonElement,
  CheckboxProps & {
    parent?: boolean;
    size?: CheckboxSize;
    variant?: 'circle' | 'square';
  }
>((props, ref) => {
  const { variant = 'square' } = props;

  if (variant === 'circle') {
    return <CircularCheckbox {...props} ref={ref} />;
  }

  return <DefaultCheckbox {...props} ref={ref} />;
});

Checkbox.displayName = 'Checkbox';

export { BaseCheckbox, CheckboxProps };
export default React.memo(Checkbox);
